import { Injectable, inject } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class IonicstorageService {
  private storage: Storage = inject(Storage);
  constructor() {
    this.init();
  }
  async init() {
    await this.storage.create();
  }
  // Save data
  async set(key: string, value: any) {
    await this.storage.set(key, value);
  }
  // Get data
  async get(key: string) {
    return await this.storage.get(key);
  }
  // Remove item
  async remove(key: string) {
    await this.storage?.remove(key);
  }
  // Clear all data
  async clear() {
    await this.storage?.clear();
  }
}
